// extracted by mini-css-extract-plugin
export default {"parent":"PageNotFound_parent__CTR2f","banSec":"PageNotFound_banSec__kDwm3"};